import React from 'react';
import GeneralCardV2 from './GeneralCardV2';
import AllocationsCardV2 from './AllocationsCardV2';
import LimitsCardV2 from './LimitsCardV2';
import LeverageCardV2 from './LeverageCardV2';
import MetricsCardV2 from './MetricsCardV2';
import BlueprintDatesCard from './BlueprintDatesCard';
import BlueprintScheduleCard from './BlueprintScheduleCard';
import './inline_edit.css';

/**
 * Seamless "v2" of Settings3 → General Settings. Same three-column order as the
 * current General view (General → Allocations · Limits → Leverage · Metrics),
 * but the editable tables use always-mounted "ghost" controls (no Edit mode, no
 * resize). GeneralPanel is reused unchanged (it has no edit-mode table). All
 * wiring/redux is identical to the current panels — only the interaction model
 * changes. Mounted alongside the current view behind a dev toggle.
 *
 * `blueprintMode` (admin blueprint authoring only) adds an editable historical-
 * window card at the top of the first column. Trainer/in-session usage omits the
 * prop, so the General view is exactly as before.
 */
const GeneralViewV2: React.FC<{ blueprintMode?: boolean }> = ({
  blueprintMode,
}) => (
  <div className="set3b-general set3b-genv2">
    <div className="set3b-col">
      {blueprintMode && <BlueprintDatesCard />}
      {blueprintMode && <BlueprintScheduleCard />}
      <GeneralCardV2 blueprintMode={blueprintMode} />
      <AllocationsCardV2 />
    </div>
    <div className="set3b-col">
      <LimitsCardV2 />
      <LeverageCardV2 />
    </div>
    <div className="set3b-col">
      <MetricsCardV2 />
    </div>
  </div>
);

export default GeneralViewV2;
